import { useTenantRuntime } from "../config/TenantRuntime";
import { Card, Field, Button, Badge } from "../components/ui";

const moduleLabels: Record<string, string> = {
  dashboard: "Início",
  customers: "Clientes",
  sales: "Vendas",
  sellers: "Equipe comercial",
  catalog: "Produtos",
  contracts: "Contratos",
  billing: "Financeiro",
  commissions: "Comissões",
  telemedicine: "Telemedicina",
  funeral_assistance: "Assistência",
  client_portal: "Portal do cliente",
  public_onboarding: "Autocadastro",
  public_payment_portal: "Segunda via",
  integrations: "Integrações",
  imports: "Importações",
  reports: "Relatórios",
  audit: "Auditoria",
  settings: "Configurações",
  customer_360: "Customer 360",
  custom_fields: "Campos personalizados",
  workflow_engine: "Workflows",
  notifications: "Notificações",
  document_builder: "Documentos",
  universal_importer: "Importador universal",
  universal_billing: "Faturamento universal",
};

export function SettingsPage() {
  const { tenant, modules } = useTenantRuntime();
  return (
    <div className="settings-grid">
      <Card title="Empresa e tenant">
        <div className="form-grid">
          <Field label="Nome fantasia">
            <input defaultValue={tenant.organization.tradeName} />
          </Field>
          <Field label="Slug">
            <input defaultValue={tenant.slug} disabled />
          </Field>
          <Field label="Fuso horário">
            <input defaultValue={tenant.organization.timezone} />
          </Field>
          <Field label="Plano">
            <input defaultValue={tenant.product.planCode} disabled />
          </Field>
        </div>
        <div className="card-actions">
          <Button>Salvar configurações</Button>
        </div>
      </Card>

      <Card title="Módulos habilitados">
        <div className="module-badges">
          {modules.map((module) => (
            <Badge key={module} tone="info">
              {moduleLabels[module] ?? module}
            </Badge>
          ))}
        </div>
      </Card>

      <Card title="Gate de produção">
        <ul className="feature-list">
          <li>Preço aprovado: {tenant.businessConfig.pricingApproved ? "sim" : "pendente"}</li>
          <li>Split aprovado: {tenant.businessConfig.splitApproved ? "sim" : "pendente"}</li>
          <li>
            Comissão aprovada: {tenant.businessConfig.commissionApproved ? "sim" : "pendente"}
          </li>
          <li>
            Contratos aprovados: {tenant.businessConfig.legalDocumentsApproved ? "sim" : "pendente"}
          </li>
          <li>Migração aprovada: {tenant.businessConfig.migrationApproved ? "sim" : "pendente"}</li>
        </ul>
      </Card>
    </div>
  );
}
